import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=c8814b18"
import script from "./KanbanCard.vue?vue&type=script&lang=js"
export * from "./KanbanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports